import React, { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { GlobalContext } from "../../../../global/context/Provider";
import { hideModal } from "../../../context/Actions/modal/modal";
import camelize from "../../../../global/utils/camelize";
import "./ModalSeleccionarFamiliar.css";
import { IoPersonCircle, IoCheckmarkCircle, IoChevronForward, IoClose, IoLockClosed } from "react-icons/io5";

const ModalSeleccionarFamiliar = ({ familiares, onSelectFamiliar }) => {
  const { modalDispatch, selectDropDownState } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);

  const handleSelectFamiliar = (familiar) => {
    onSelectFamiliar(familiar);
    hideModal()(modalDispatch);
  };

  const handleClose = () => {
    hideModal()(modalDispatch);
  };

  const isSelected = (familiar) => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      return selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id === familiar.id;
    }
    return authState.auth.data.paciente.codigo === familiar.id;
  };

  const isTitular = (familiar) => {
    return !familiar.familiar;
  };

  const sinPermisos = (familiar) => {
    return familiar.familiar && !familiar.manejoTurnos;
  };

  return (
    <div className="modal-seleccionar-familiar">
      <div className="modal-seleccionar-familiar-header">
        <h2 className="modal-seleccionar-familiar-titulo">Seleccionar familiar</h2>
        <button className="modal-seleccionar-familiar-close" onClick={handleClose}>
          <IoClose size={24} />
        </button>
      </div>
      <div className="modal-seleccionar-familiar-lista">
        {familiares.map((familiar, index) => {
          const selected = isSelected(familiar);
          const titular = isTitular(familiar);
          const noPermiso = sinPermisos(familiar);
          
          return (
            <div
              key={index}
              className={`modal-seleccionar-familiar-item${noPermiso ? " modal-seleccionar-familiar-item--sin-permiso" : ""}`}
              onClick={() => handleSelectFamiliar(familiar)}
            >
              <div className="modal-seleccionar-familiar-item-left">
                <div className="modal-seleccionar-familiar-info">
                  <div className="modal-seleccionar-familiar-nombre">
                    {camelize(familiar.nombre)}
                    {titular && (
                      <span className="modal-seleccionar-familiar-badge">Sesión iniciada</span>
                    )}
                    {noPermiso && (
                      <span className="modal-seleccionar-familiar-badge--sin-permiso">
                        <IoLockClosed size={10} />
                        Sin permisos
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-seleccionar-familiar-item-right">
                {selected ? (
                  <IoCheckmarkCircle size={24} color="#0A5F8F" />
                ) : (
                ""
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ModalSeleccionarFamiliar;

